import * as React from "react";
import * as styles from "./TeamAvatar.less";

export const TeamAvatar: React.FC = () => <div className={styles.team_avatar} />;
